module.exports = __webpack_public_path__ + "img/map.0f27805d.jpg";